import { Injectable } from '@angular/core';
import { Configuration, ConfigurationParameters } from 'openapi/build/configuration';
import { environment } from 'src/environments/environment';

/**
 * Ce service permet de charger des configurations dynamiques pour l'API.
 */
@Injectable({
  providedIn: 'root'
})
export class ApiConfigurationService {
  constructor() {}
}

/**
 * Retourne les paramêtres de configuration de l'API.
 */
export function apiConfigFactory(): Configuration {
  const params: ConfigurationParameters = {
    // set configuration parameters here.
    basePath: environment.API_BASE_PATH,
    // TODO : activer les credentials pour l'authentification sur l'API.
    withCredentials: false
  };

  return new Configuration(params);
}
